import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import AutoFaxModal from './AutoFaxModal';

interface FaxSettingsFormProps {
  fax: string;
  isFaxEnabled: boolean;
  showAutoFaxModal: boolean;
  onFaxChange: (val?: string) => void;
  onAutoFaxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onConfirmAutoFax: () => void;
  onHideModal: () => void;
}

export default function FaxSettingsForm({
  fax,
  isFaxEnabled,
  showAutoFaxModal,
  onFaxChange,
  onAutoFaxChange,
  onConfirmAutoFax,
  onHideModal,
}: FaxSettingsFormProps) {
  return (
    <>
      <Form.Group className='col-md-6 mb-2'>
        <Form.Label htmlFor='fax-input'>Fax Number</Form.Label>
        <PhoneInput
          id='fax-input'
          placeholder='Enter fax number'
          value={fax}
          onChange={onFaxChange}
          defaultCountry='US'
          numberInputProps={{ className: 'form-control' }}
        />
      </Form.Group>

      <Form.Group className='col-12 mb-2'>
        <Form.Check
          type='checkbox'
          id='is_fax_enabled'
          name='is_fax_enabled'
          checked={isFaxEnabled}
          onChange={onAutoFaxChange}
          disabled={!fax}
          label={
            <span className='d-flex align-items-center'>
              Auto-Fax Results
              <OverlayTrigger
                placement='top'
                overlay={
                  <Tooltip id='auto-fax-tooltip'>
                    When enabled, results will be automatically faxed to the number provided upon report completion.
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faCircleQuestion} className='ms-2 text-muted cursor-pointer' />
              </OverlayTrigger>
            </span>
          }
        />
      </Form.Group>

      <AutoFaxModal show={showAutoFaxModal} onHide={onHideModal} onConfirm={onConfirmAutoFax} />
    </>
  );
}
